module.exports = __webpack_public_path__ + "media/bootstrap-icons/zoom-in-fe3a662a.svg";